import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import wikiList from '@/pages/wiki/wikiList.vue'
import wikiPage from '@/pages/wiki/wikiPage.vue'

// @ts-ignore
import messages from '@/lang/index'

const wiki: RouteConfig = {
  path: '/wiki',
  name: 'wiki',
  meta: {
    pageName: messages.wiki.nodes
  },
  component: DashboardLayout,
  redirect: '/wiki/list',
  children: [
    {
      path: 'list',
      name: 'wikiList',
      meta: {
        pageName: messages.wiki.node_list
      },
      component: wikiList
    },
    {
      path: '/wiki/:id',
      name: 'wikiPage',
      meta: {
        pageName: messages.wiki.node
      },
      component: wikiPage,
      props: true
    }
  ]
}
export default wiki;